import type { LinksFunction, LoaderFunctionArgs, MetaFunction } from "@remix-run/node";
import { json, redirect } from "@remix-run/node";
import { Public } from "~/utils/remix";
import type { Users } from "@prisma/client";
import logo from "~/assets/mlnplogoheart.webp";
import discoverStyles from "~/styles/discover.css";

export const links: LinksFunction = () => [
{ rel: "preconnect", href: "https://fonts.googleapis.com" },
{ rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" },
{
  rel: "stylesheet",
  href: "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,300;1,400&family=DM+Sans:wght@300;400;500&display=swap"
},
{ rel: "stylesheet", href: discoverStyles }];


export const meta: MetaFunction = () => {
  return [
  { title: "Contact Us — Discover MakeLoveNotPorn" },
  { property: "og:title", content: "Contact Us" },
  { name: "description", content: "Questions? Feedback? Troubles? Contact us!" }];

};

export const loader = Public(async ({ request, context }: LoaderFunctionArgs) => {
  if ((context.user as Users)?.IsAgeVerified) {
    return redirect("/talk-to-us");
  }

  return json({});
});

export default function DiscoverContactUs() {
  return (
    <div className="discover-page font-dm font-light overflow-x-hidden bg-[var(--d-bg)] text-[var(--d-fg)] min-h-screen flex flex-col">
      <nav className="fixed top-0 left-0 right-0 z-[100] flex items-center justify-between px-6 lg:px-12 py-5 bg-[hsla(24,14%,96%,0.93)] backdrop-blur-[14px] border-b border-[var(--d-border)]">
        <a
          href="/discover"
          className="font-cormorant text-[22px] font-semibold tracking-[0.04em] text-[var(--d-fg)] no-underline">

          <img src={logo} alt="MakeLoveNotPorn" className="h-14 sm:hidden" />
          <span className="hidden sm:inline">MakeLoveNotPorn<span className="text-[var(--d-orange)]">.tv</span></span>
        </a>
        <a
          href="/discover#pricing"
          className="bg-[var(--d-orange)] text-white px-6 py-2.5 text-[13px] font-medium tracking-[0.06em] uppercase no-underline transition-colors hover:bg-[var(--d-orange-dark)]">

          Subscribe
        </a>
      </nav>

      <div className="pt-28 pb-20 px-6 lg:px-16 flex-1">
        <div className="max-w-3xl mx-auto">
          <a
            href="/discover"
            className="text-[var(--d-orange)] text-[13px] tracking-[0.06em] uppercase no-underline hover:text-[var(--d-orange-dark)] transition-colors mb-8 inline-block">

            &larr; Back to Discover MakeLoveNotPorn
          </a>
          <h1 className="font-cormorant text-[clamp(36px,4vw,54px)] font-light leading-[1.15] mb-10">
            Talk to Us
          </h1>
          <div className="prose prose-sm max-w-none text-[var(--d-fg-muted)] prose-headings:font-cormorant prose-headings:text-[var(--d-fg)] prose-a:text-[var(--d-orange)] prose-a:no-underline hover:prose-a:text-[var(--d-orange-dark)] prose-strong:text-[var(--d-fg)]">
            <h3>Questions about curation, profiles, etc?</h3>
            <p>
              Email <a href="mailto:curators@makelovenotporn.tv">curators@makelovenotporn.tv</a>
            </p>
            <h3>Tech or billing troubles? General site stuff?</h3>
            <p>
              Email <a href="mailto:support@makelovenotporn.tv">support@makelovenotporn.tv</a>
            </p>
            <h3>Feedback, comments, suggestions?</h3>
            <p>
              Email <a href="mailto:feedback@makelovenotporn.tv">feedback@makelovenotporn.tv</a>
            </p>
            <h3>If you're a brand/business interested in working with MLNP.tv:</h3>
            <p>
              Email <a href="mailto:cindy@makelovenotporn.tv">cindy@makelovenotporn.tv</a>
            </p>
          </div>
        </div>
      </div>

      <footer className="bg-[var(--d-dark-deep)] text-[rgba(255,248,244,0.3)] px-6 lg:px-16 py-10 flex flex-wrap sm:flex-nowrap items-center justify-between gap-y-4 text-[12px]">
        <img src={logo} alt="MakeLoveNotPorn" className="h-12 brightness-[0.95]" />
        <div className="flex gap-7">
          <a href="/discover/privacy-policy" className="text-[rgba(255,248,244,0.3)] no-underline tracking-[0.06em] uppercase text-[11px] transition-colors hover:text-[var(--d-orange)]">Privacy</a>
          <a href="/discover/terms-of-service" className="text-[rgba(255,248,244,0.3)] no-underline tracking-[0.06em] uppercase text-[11px] transition-colors hover:text-[var(--d-orange)]">Terms</a>
          <a href="/discover/contact-us" className="text-[rgba(255,248,244,0.3)] no-underline tracking-[0.06em] uppercase text-[11px] transition-colors hover:text-[var(--d-orange)]">Contact</a>
        </div>
        <span>&copy; 2025 MakeLoveNotPorn</span>
      </footer>
    </div>);

}